<template>
  <WalletTakt
    :selected="$route.matched[3] &&
              ['ProjectWalletWorkPackageInfo',
              'ProjectWalletWorkCards',
              'ProjectWalletQualityCards',
              'ProjectWalletDefectCards',
              'ProjectWalletHandoverCards',
              'ProjectWalletLogisticCards',
              'ProjectWalletDesignCards'
              ].includes($route.matched[3].name) &&
              wallet_column === selected_column?true:false"
    @touchstart.native="setMobileWalletShowSettings(false)"
    >
    <template #header>
    <WalletTaktHeader
      :takt_time="takt_index >= -1 &&
                  takt_index <= getCalendar(project_id).takt_times.length?
                  getCalendar(project_id).takt_times[takt_index]:false"
      :show_calendar_weeks="isShowCalendarWeeks"
      @click.native="setShowCalendarWeeks"
      >
      <template #settings-button>
        <v-icon
          v-if="$vuetify.breakpoint.smAndDown && !$route.matched[3] ||
            $vuetify.breakpoint.smAndDown && $route.matched[3] &&
            $route.matched[3].name !== 'ProjectWalletWorkPackageInfo'"
          @click.prevent.stop="setMobileWalletShowSettings(true)"
          >
          settings
        </v-icon>
      </template>
    </WalletTaktHeader>
    </template>
    <template #body>
        <template>
          <WalletTaktBody>
            <WalletTrain
              v-for="(section, section_index) in getSectionArray()"
              :key="`section${section_index}`"
              :shadow="section_index === 0?false:true"
              :no_margin_top="section_index === 0?true:false"
              :wallet_settings="getWalletSettings"
              :step_cards="getStepCards({
                project_id: project_id,
                takt_index: takt_index,
                section: section,
                })"
              >
              <template #name="{wallet_settings}">
                <div
                  v-if="wallet_settings.sorting === 'trains' || !wallet_settings.sorting"
                  >
                  {{getTrain(section).name}}
                </div>
                <div
                  v-else-if="wallet_settings.sorting === 'colors'"
                  :class="`color-badge ${section.value} ${section.value.includes('lighten') || section.value.includes('darken')? '':'lighten-1'} t-shadow`"
                  />
                <v-icon
                  v-else-if="wallet_settings.sorting === 'status'"
                  >
                  {{section.icon}}
                </v-icon>
              </template>
              <template #content="{wallet_settings, step_cards}">
                <template v-if="isWalletShowWorkpackages">
                  <WalletWorkPackage
                    v-for="(twork_package, twork_package_index) in getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section)"
                    :key="twork_package.id"
                    :twork_package="twork_package"
                    :previous_twork_package="getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section)[twork_package_index-1]"
                    :selected="tworkpackage_id === twork_package.id?'-selected':''"
                    :other_selected="$route.matched[3] && $route.matched[3].name === 'ProjectWalletWorkPackageInfo' &&
                                      wallet_column === selected_column &&
                                      tworkpackage_id !== twork_package.id?'-other-selected':''"
                    >
                    <template #header="{twork_package, previous_twork_package}">
                      <WalletWorkPackageCutOut
                        :color="isShowOwnWps &&
                          getOwnTWorkPackages(project_id).length !== 0 &&
                          !getOwnTWorkPackages(project_id).includes(twork_package.id)?
                          'grey darken-2':`${twork_package.color} ${twork_package.color.includes('lighten') || twork_package.color.includes('darken')? '':'lighten-1'}`"
                        :status_index="twork_package_index === 0?-1:
                          (previous_twork_package.stop_status !== 'none'?
                          getStatusArray.slice(0,-1).length:
                          (getStatusArray.slice(0,-1).findIndex(status => status.name === previous_twork_package.status)))"
                        :status_count="getStatusArray.slice(0,-1).length+1"
                        @click.native="walletWorkpackageClick(twork_package)"
                        />
                      <WalletWorkPackageHeader
                        :color="isShowOwnWps &&
                          getOwnTWorkPackages(project_id).length !== 0 &&
                          !getOwnTWorkPackages(project_id).includes(twork_package.id)?
                          'grey darken-2':`${twork_package.color} ${twork_package.color.includes('lighten') || twork_package.color.includes('darken')? '':'lighten-1'}`"
                        :text="`${getWalletWorkpackageHeaderItems.includes('token')?twork_package.token:''}
                                ${getWalletWorkpackageHeaderItems.length > 1?' - ':''}
                                ${getWalletWorkpackageHeaderItems.includes('name')?twork_package.name:''}
                                ${twork_package && twork_package.workpackage_part > 1 ? '[' + twork_package.workpackage_part + ']' : '' }
                                `"
                        :icon="twork_package.icon"
                        :textcolor="twork_package.textcolor"
                        :taktarea_name="twork_package.taktarea.name"
                        @click.native="walletWorkpackageClick(twork_package)"
                      />
                      <WalletWorkPackageStatus
                        :color="isShowOwnWps &&
                          getOwnTWorkPackages(project_id).length !== 0 &&
                          !getOwnTWorkPackages(project_id).includes(twork_package.id)?
                          'grey darken-2':`${twork_package.color} ${twork_package.color.includes('lighten') || twork_package.color.includes('darken')? '':'lighten-1'}`"
                          :textcolor="twork_package.textcolor"
                        >
                        <WaggonInfoStatus
                          :textcolor="twork_package.textcolor"
                          v-for="status in getStatusArray.slice(0, -1)"
                          :key="status.name"
                          :status="status"
                          :selected="twork_package.status === status.name?true:false"
                          :bold="twork_package.status === status.name?true:false"
                          :no_text="$vuetify.breakpoint.smAndDown?true:false"
                          :no_border="$vuetify.breakpoint.smAndDown?false:false"
                          width="16.66%"
                          :cursor="
                          hasProjectPermission({
                            project_id: project_id,
                            ppermission: 'Update Work Packages'
                            }) ||
                          getOwnTWorkPackages(project_id).includes(twork_package.id)?
                          'pointer':'default'
                          "
                          @click.native="
                          hasProjectPermission({
                            project_id: project_id,
                            ppermission: 'Update Work Packages'
                            }) ||
                          getOwnTWorkPackages(project_id).includes(twork_package.id)?
                          updateUObject({
                            url: [
                              {projects: project_id},
                              {trains: twork_package.train.id},
                              {taktareas: twork_package.taktarea.id},
                              {twaggons: twork_package.twaggon.id},
                              {tworkpackages: twork_package.id},
                            ],
                            url_suffix: '/status',
                            update: {
                              status: twork_package.status !== status.name?status.name:'none'
                            }
                            })
                          :''"
                          />
                          <WaggonInfoStatus
                            :textcolor="twork_package.textcolor"
                            :status="{name: 'stop', icon: twork_package.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'}"
                            :selected="twork_package.stop_status !== 'none'"
                            width="16.66%"
                            :cursor="
                            hasProjectPermission({
                              project_id: project_id,
                              ppermission: 'Update Work Packages'
                              }) ||
                            getOwnTWorkPackages(project_id).includes(twork_package.id)?
                            'pointer':'default'
                            "
                            @click.native="
                              hasProjectPermission({
                                project_id: project_id,
                                ppermission: 'Update Work Packages'
                                }) ||
                              getOwnTWorkPackages(project_id).includes(twork_package.id)
                              ?
                              updateUObject({
                                url: [
                                  {projects: project_id},
                                  {trains: twork_package.train.id},
                                  {taktareas: twork_package.taktarea.id},
                                  {twaggons: twork_package.twaggon.id},
                                  {tworkpackages: twork_package.id},
                                ],
                                url_suffix: '/stopstatus',
                                update: {
                                  stop_status: twork_package.stop_status !== 'none'?'none':'stop'
                                }
                              })
                            :''"
                            />
                        </WalletWorkPackageStatus>
                    </template>
                    <template #body>
                      <router-view
                        v-if="$route.matched[3] && $route.matched[3].name === 'ProjectWalletWorkPackageInfo' &&
                        tworkpackage_id === twork_package.id"
                        :key="tworkpackage_id+$route.matched[3].name"
                        />
                    </template>
                  </WalletWorkPackage>
                </template>
                <!-- Step Cards -->
                <template v-for="(step_type, step_type_index) in ['work', 'quality', 'defect', 'handover', 'logistic', 'design']">
                  <WalletWorkPackage
                    v-for="(step_card, step_card_index) in step_cards[`${step_type}_cards`]"
                    :key="`${step_type}card${step_card.id}`"
                    :selected="$props[`${step_type}_card_id`] === step_card.id?'-selected':''"
                    :other_selected="$route.matched[3] && $route.matched[3].name === `ProjectWallet${step_type.substring(0,1).toUpperCase()}${step_type.substring(1)}Cards` &&
                                      wallet_column === selected_column &&
                                      $props[`${step_type}_card_id`] !== step_card.id?'-other-selected':''"
                    >
                    <template #header>
                      <WalletWorkPackageCutOut
                        color="white"
                        :status_index="step_card_index !== 0 ||
                        getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section).length === 0
                        ?-1:
                        (getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section)[getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section).length-1].stop_status !== 'none'?
                        getStatusArray.length:
                          getStatusArray.findIndex(status =>
                            status.name === getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section)[getWorkpackagesInTaktComputed(takt_index, wallet_settings.sorting, section).length-1].status))"
                        :status_count="getStatusArray.length+1"
                        @click.native="
                          $props[`${step_type}_card_id`] === step_card.id?
                          $router.push({
                            name: 'ProjectWalletTakt'
                            }):
                          $router.push({
                          name: `ProjectWallet${step_type.substring(0,1).toUpperCase()}${step_type.substring(1)}Cards`,
                          params: {
                            project_id: project_id,
                            train_id: step_card.train_id,
                            taktarea_id: step_card.taktarea_id,
                            twaggon_id: step_card.twaggon_id,
                            tworkpackage_id: step_card.work_package_id,
                            takt_index: $route.params.takt_index,
                            [`${step_type}_card_id`]: step_card.id,
                            selected_column: wallet_column,
                          }
                          })"
                        />
                      <WalletWorkPackageHeader
                        color="white"
                        :text="`${getWalletWorkpackageHeaderItems.includes('token')?step_card.work_package_token:''}
                                ${getWalletWorkpackageHeaderItems.length > 1?' - ':''}
                                ${getWalletWorkpackageHeaderItems.includes('name')?step_card.work_package_name:''}
                                `"
                        :icon="['takt_workstep', 'takt_quality', 'takt_defect', 'takt_handover', 'takt_logistic', 'takt_design'][step_type_index]"
                        :taktarea_name="step_card.taktarea_name"
                        @click.native="
                          $props[`${step_type}_card_id`] === step_card.id?
                          $router.push({
                            name: 'ProjectWalletTakt'
                            }):
                          $router.push({
                          name: `ProjectWallet${step_type.substring(0,1).toUpperCase()}${step_type.substring(1)}Cards`,
                          params: {
                            project_id: project_id,
                            train_id: step_card.train_id,
                            taktarea_id: step_card.taktarea_id,
                            twaggon_id: step_card.twaggon_id,
                            tworkpackage_id: step_card.work_package_id,
                            takt_index: $route.params.takt_index,
                            [`${step_type}_card_id`]: step_card.id,
                            selected_column: wallet_column,
                          }
                          })"
                      >
                      <template #step-button>
                        <v-btn
                          icon
                          :class="`${step_card.work_package_color} ${step_card.work_package_color.includes('lighten') || step_card.work_package_color.includes('darken')? '':'lighten-1'} mr-1`"
                          style="height: 18px; width: 18px"
                          small
                          @click.prevent.stop="updateUObject({
                            url: [
                              {projects: project_id},
                              {trains: step_card.train_id},
                              {taktareas: step_card.taktarea_id},
                              {twaggons: 0},
                              {tworkpackages: step_card.work_package_id},
                              {[`t${step_type}steps`]: step_card.id},
                            ],
                            url_suffix: '/updatedone',
                            update: {
                              done: !step_card.done
                            }
                          }).then(() => {
                            updateStepCardStatus({
                              project_id: project_id,
                              step_id: step_card.id,
                              step_type: step_type,
                              done: !step_card.done,
                              offset: step_card.offset,
                              wallet_column: wallet_column,
                              })
                            }).then(() => {
                              increaseUpdateKeyStepCard()
                              })
                          "
                          >
                          <!-- @click.prevent.stop="updateTWorkStepStatus({
                            project_id: project_id,
                            train_id: step_card.train_id,
                            taktarea_id: step_card.taktarea_id,
                            twaggon_id: 0,
                            twork_package_id: step_card.work_package_id,
                            twork_step_id: step_card.id,
                            data: {
                              done: !step_card.done
                            },
                            [`${step_type}_card`]: true,
                            takt_index: takt_index,
                          })" -->
                          <v-icon
                            color="black"
                            :key="`${step_card.id}stepcard${getUpdateKeyStepCard}`"
                            >
                            {{step_card.done?'check_circle_outline':'panorama_fish_eye'}}
                          </v-icon>
                        </v-btn>
                      </template>
                      <template #step-offset>
                        <div
                          class="mr-8"
                          >
                          {{step_type !== 'work'?`${step_card.offset > 0?'+':''}${step_card.offset}`:0}} TT
                        </div>
                      </template>
                      </WalletWorkPackageHeader>
                      <WalletWorkPackageStatus
                        color="white"
                        justify_content="flex-start"
                        @click.native="
                          $props[`${step_type}_card_id`] === step_card.id?
                          $router.push({
                            name: 'ProjectWalletTakt'
                            }):
                          $router.push({
                          name: `ProjectWallet${step_type.substring(0,1).toUpperCase()}${step_type.substring(1)}Cards`,
                          params: {
                            project_id: project_id,
                            takt_index: $route.params.takt_index,
                            [`${step_type}_card_id`]: step_card.id,
                            selected_column: wallet_column,
                          }
                          })"
                        >
                        <div class="ml-1 mr-1">{{step_card.text}}</div>
                      </WalletWorkPackageStatus>
                    </template>
                    <template #body>
                      <router-view
                        />
                        <!-- v-if="$route.matched[3] && $route.matched[3].name === `ProjectWallet${step_type.substring(0,1).toUpperCase()}${step_type.substring(1)}Cards` &&
                        $props[`${step_type}_card_id`] === step_card.id" -->
                    </template>
                  </WalletWorkPackage>
                </template>
              </template>
            </WalletTrain>
            <WalletTrain
              :shadow="true"
              :no_margin_top="false"
              />
          </WalletTaktBody>
        </template>
    </template>
  </WalletTakt>
</template>
<script>
  import { WalletMixin } from '@/mixins/Wallet.mixin.js'
  export default {
    props: [
      'project_id',
      'takt_index',
      'tworkpackage_id',
      'workstep_card_id',
      'work_card_id',
      'quality_card_id',
      'defect_card_id',
      'handover_card_id',
      'logistic_card_id',
      'design_card_id',
      'wallet_column',
      'selected_column'
    ],
    mixins: [
      WalletMixin
    ],
  }
</script>
<style>
</style>
